import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * SampleDataBanner — BUS-13 / P1 honesty: clearly marks screens that render illustrative/sample
 * data not yet wired to live tenant analytics, so fabricated figures are never presented as live.
 */
export default function SampleDataBanner({ label }) {
  return (
    <div className="mb-4 flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>{label || 'Sample data — this view is not yet connected to live analytics. Figures shown are illustrative. Use the live dashboards (Overview / Analytics → Refresh) for real data.'}</span>
    </div>
  );
}
